import React from 'react';
import Header from '../components/Header';
import HeroSlider from '../components/HeroSlider';
import About from '../components/About';
import Services from '../components/Services';
import Industries from '../components/Industries';
import Healthcare from '../components/Healthcare';
import WhyGhana from '../components/WhyGhana';
import Licences from '../components/Licences';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <div className="bg-white">
      <Header />
      <HeroSlider />
      <About />
      <Services />
      <Industries />
      <Healthcare />
      <WhyGhana />
      <Licences />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
